import { COLOR, Heading as _Heading, mq, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { Carousel as _Carousel } from "~/components/blocks/common/carousel";
import { ROOT_PADDING } from "~/styles/padding";

// MEMO : 関連ブックは角を削ってはならない(書影の扱いはブックのレギュレーションがあるため)のでブックのみborder-radiusを0にする
export const BooksCarousel = styled(_Carousel)`
  img {
    border-radius: 0px;
  }
`;

export const Heading = styled(_Heading)`
  padding: 0 ${ROOT_PADDING.PC}px;
  margin-bottom: 8px;
  color: ${COLOR.GRAY900.code};
  font-weight: ${FONT_WEIGHT.BOLD};
  ${mq.sp} {
    padding: 0 ${ROOT_PADDING.SP}px;
  }
`;
